import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { EYesNo } from '../../../../../shared/models/types.enum';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { FormUtils } from '../../../../../shared/helpers/formUtils';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'depression',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  templateUrl: './depression.component.html',
  styleUrl: './depression.component.css'
})
export class DepressionComponent implements OnInit, OnChanges {

  @Input() teacherStaffInterviewData: any;
  @Output() onSaveSection6 = new EventEmitter<any>();

  yesNo = EYesNo;
  depressionForm: FormGroup = new FormGroup([]);
  radioQuestions = [
    {
      id: 'mood_changes',
      questionText: "Have you observed changes in the student's mood, demeanor, or activity level? *",
      formControlName: 'mood_changes',
      infoFormControlName: 'mood_changes_information'
    },
    {
      id: 'withdrawn',
      questionText: "Is the student withdrawn or apathetic? *",
      formControlName: 'withdrawn',
      infoFormControlName: 'withdrawn_information'
    },
    {
      id: 'hopelessness',
      questionText: 'Has the student expressed any attitudes suggesting hopelessness, inadequacy, shame, self-criticism, or worthlessness? *',
      formControlName: 'hopelessness',
      infoFormControlName: 'hopelessness_information'
    },
    {
      id: 'irritable',
      questionText: 'Is the student irritable or short-tempered? *',
      formControlName: 'irritable',
      infoFormControlName: 'irritable_information'
    }
  ];

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private formUtils: FormUtils
  ) {}

  ngOnInit() {
    this.initializeForm();
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['teacherStaffInterviewData'] && this.teacherStaffInterviewData) {
      this.initializeForm();
    }
  }

  private initializeForm() {
    const group: any = {};

    this.radioQuestions.forEach(question => {
      const defaultValue = this.teacherStaffInterviewData && this.teacherStaffInterviewData[question.formControlName] !== undefined
                           ? this.teacherStaffInterviewData[question.formControlName]
                           : this.yesNo.No;  

      group[question.formControlName] = new FormControl(
          String(defaultValue), 
          Validators.required
      );
      group[question.infoFormControlName] = new FormControl({ value: this.teacherStaffInterviewData?.[question.infoFormControlName] || '', disabled: this.teacherStaffInterviewData?.[question.infoFormControlName] ? false : true });
    });

    this.depressionForm = new FormGroup(group);
    this.setupFormChangeHandlers();
  }

  setupFormChangeHandlers() {
    this.radioQuestions.forEach(question => {
      const control = this.depressionForm.get(question.formControlName);
      if (control) {
        control.valueChanges.subscribe(value => {
          const infoControl = this.depressionForm.get(question.infoFormControlName);
          if (infoControl) {
            this.formUtils.handleConditionChange(infoControl, value === this.yesNo.Yes);
          }
        });
      }
    });
  }  

  saveDepression(): void {
    if (this.depressionForm.valid) {
      this.onSaveSection6.emit(this.depressionForm.value);
    }
  }

}
